import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { TransferDto } from '../types';

export const useReceiptTransferSuggestions = (receiptId: string, enabled = true) => {
  const { projectId } = useParams();

  return useQuery<TransferDto[]>({
    queryKey: ['receipt-transfer-suggestions', receiptId],
    queryFn: () =>
      apiClient.get(`/v1/projects/${projectId}/receipts/${receiptId}/transfer-suggestions`),
    enabled: !!projectId && !!receiptId && enabled,
  });
};
